import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <div className="bg-cream relative overflow-hidden" data-id="element-108">
      <Section className="relative z-10" data-id="element-109">
        <div className="text-center max-w-4xl mx-auto" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-111">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-navy mb-6" data-id="element-112">
              Presentamos el Ebook: <br data-id="element-113" />
              <span className="italic text-sage-dark" data-id="element-114">
                30 Días para Despertar tu Ser
              </span>
            </h2>
            <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-115">
              Una hoja de ruta práctica y profunda basada en la metafísica del
              Yo Soy y la manifestación consciente.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative inline-block" data-id="element-116">
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform scale-110" data-id="element-117" />
            <img src="https://cdn.magicpatterns.com/uploads/dmhVPptKVVseoHeTGRvevn/portada_30_dias_para_despertar_-_ok.png" alt="Ebook Cover" className="relative z-10 w-full max-w-sm md:max-w-md mx-auto shadow-2xl rounded-lg" data-id="element-118" />
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          delay: 0.4
        }} className="mt-12 text-2xl font-heading font-semibold text-navy italic" data-id="element-119">
            "No es un libro para leer, es un libro para encarnar."
          </motion.p>
        </div>
      </Section>
    </div>;
}